// This file is auto-generated by @hey-api/openapi-ts

import * as z from 'zod';

/**
 * UUIDv4
 */
export const zId = z.uuid();

export const zDriverStatus = z.string();

/**
 * E-mail
 */
export const zEmail = z.email().max(255);

export const zIdentificationType = z.string();

export const zIdentification = z.object({
    id: zId,
    identification_type: zIdentificationType,
    identification: z.string(),
});

export const zIdentificationList = z.object({
    items: z.array(zIdentification),
});

export const zTag = z.object({
    id: zId,
});

export const zTagList = z.object({
    items: z.array(zTag),
});

export const zLink = z.object({
    href: z.string(),
});

/**
 * All links are (absolute) URLs.
 * * The `self` link shows the current page.
 * * The `next` link is only present if the result got paginated and there are still unfetched pages left.
 * Follow the `next` link to get the next pages until the `next` link is not present anymore.
 *
 */
export const zPaginationLinks = z.object({
    self: zLink,
    next: zLink.optional(),
});

export const zDriverResponse = z.object({
    id: zId,
    account_id: zId,
    status: zDriverStatus.optional(),
    email: zEmail.optional(),
    first_name: z.string().max(255).optional(),
    last_name: z.string().max(255).optional(),
    display_name: z.string().optional(),
    phone_number: z.string().max(255).optional(),
    subject: z.string().optional(),
});

export const zDriverEmbedded = zDriverResponse.and(
    z.object({
        _embedded: z
            .object({
                identifications: z.array(zIdentification).optional(),
                tags: z.array(zTag).optional(),
            })
            .optional(),
    })
);

export const zDriversEmbeddedList = z.object({
    items: z.array(zDriverEmbedded),
    _links: zPaginationLinks,
});

export const zDriverRequest = z.object({
    id: zId,
    account_id: zId,
    status: zDriverStatus.optional(),
    email: zEmail.optional(),
    first_name: z.string().max(255).optional(),
    last_name: z.string().min(1).max(255),
    phone_number: z.string().max(255).optional(),
    subject: z.string().optional(),
});

/**
 * Driver Id
 */
export const zDriverId = zId;

/**
 * Driver Identification Id
 */
export const zIdentificationId = zId;

/**
 * Account Id
 */
export const zAccountId = zId;

/**
 * Tag Id
 */
export const zTagId = zId;

/**
 * Identification identifier - In combination with identifcation_type
 */
export const zIdentification2 = z.string();

/**
 * Driver status
 */
export const zStatus = zDriverStatus;

/**
 * A query for searching. Currently no query language is defined, but we might add this later. This parameter is meant for UIs to pass simple search queries from human users. The interpretation of this string can change over time and we do not guarantee backwards compatibility.
 *
 */
export const zQuery = z.string();

/**
 * Limit the number of returned resources in list
 */
export const zLimit = z.int();

/**
 * offset for pagination
 */
export const zAfter = z.string();

/**
 * Embed optional sub resources
 */
export const zEmbed = z.string();

/**
 * Driver Identification Type
 */
export const zIdentificationType2 = zIdentificationType;

/**
 * The subject that is assigned to the driver
 */
export const zSubject = z.string();
